import Administration from "@/views/modules/Administration/Administration.vue";
import layouts from "@/layout.js";
import Providers from "@/views/modules/projects/Providerlist.vue";

export default {
  path: "/Administration",
  name: "Administration",
  component: Administration,
  meta: {
    auth: true,
    title: "Administración",
    tags: ["administración"]
  },
  redirect: {
    name: "admin-provider"
  },
  children: [
    {
      path: "Provider",
      name: "admin-provider",
      component: Providers,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Proveedores",
        tags: ["administration", "provider"],
        index: true
      }
    }
    // {
    //   path: "reportsurvey",
    //   name: "employees-reportsurvey",
    //   component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Respuesta de Empleados",
    //     index: true,
    //     // Pass props to the component
    //     props: {
    //       // Define your props here
    //       prop1: "value1",
    //       prop2: "value2"
    //       // ...,
    //     }
    //   }
    // }
  ]
};
